import { ContainerComponent, wrap } from 'AppReact';
import { Input, InputError } from 'molecules';
import { Seprator, SubSectionLabel } from '../../../../common/atoms';
import { SubsectionHeader } from '../../../../common/molecules';
import Schema from 'AppReact/schema';
import { FieldWrapper } from '../../../../common/wrappers';
import Controller from './controller';
import { vehicleSechema, defaultVehicle } from '../../../../types'
import { GenericWrapper } from 'wrappers';
import { isLastItem } from '../../../../utils';

const WrappedInput = wrap(Input, FieldWrapper);
const WrappedInputError = wrap(InputError, FieldWrapper);

const Vehicle = {
    controller: Controller,
    name: "Vehicle",
    initialProps: ({ vehicleIndex, language, vehicle, vehicles, onReview }) => ({ vehicleIndex, language, vehicle, vehicles, onReview }),
    props: {
        vehicle: Schema(vehicleSechema, 'object', { defaultValue: defaultVehicle }),
        vehicles: Schema(vehicleSechema, 'array'),
        vehicleIndex: Schema('integer', 'primitive'),
        onReview: Schema('boolean', 'primitive'),
        language: Schema( {}, 'object'),
    },
    elements: [
        {
            wrapper: GenericWrapper,
            name: 'VehicleForm',
            elements: [
                {
                    component: SubSectionLabel,
                    name: 'SubSectionLabel',
                    renderIf: ({ vehicles, vehicleIndex }) => vehicles && vehicles?.length> 0 && vehicleIndex == 0,
                    displayValue: ({ vehicle }) => vehicle?.modal || "Vehicle model",
                },
                {
                    component: SubsectionHeader,
                    name: 'DeleteButton',
                    renderIf: ({ vehicles, vehicleIndex }) => vehicles && vehicles?.length> 0 && vehicleIndex !== 0,
                    bindings: ({ vehicle, vehicles, vehicleIndex }) => ({ label: vehicle?.modal || "Vehicle model", resourceList: vehicles, vehicleIndex })
                },
                {
                    component: WrappedInput,
                    name: 'Model',
                    bindings: ({ language, vehicle, vehicles, vehicleIndex }) => ({ vehicleIndex, vehicles, vehicle, label: `${language?.model || 'Make/Model'}:`, value: vehicle.modal })
                },
                {
                    component: WrappedInputError,
                    name: 'ModelError',
                    bindings: ({ vehicle }) => ({ error: vehicle.modalError }),
                    renderIf: ({ vehicle, onReview }) => !!vehicle.modalError && !onReview
                },
                {
                    component: WrappedInput,
                    name: 'Color',
                    bindings: ({ language, vehicle, vehicles, vehicleIndex }) => ({ vehicleIndex, vehicles, vehicle, label: `${language?.color || 'Color'}:`, value: vehicle.color })
                },
                {
                    component: WrappedInputError,
                    name: 'ColorError',
                    bindings: ({ vehicle }) => ({ error: vehicle.colorError }),
                    renderIf: ({ vehicle, onReview }) => !!vehicle.colorError && !onReview
                },
                {
                    component: WrappedInput,
                    name: 'LicensePlate',
                    bindings: ({ language, vehicle, vehicles, vehicleIndex }) => ({ vehicleIndex, vehicles, vehicle, label: `${language?.license || 'License Plate'}:` , value: vehicle.licensePlate })
                },
                {
                    component: WrappedInputError,
                    name: 'LicensePlateError',
                    bindings: ({ vehicle }) => ({ error: vehicle.licensePlateError }),
                    renderIf: ({ vehicle, onReview }) => !!vehicle.licensePlateError && !onReview
                },
                {
                    component: WrappedInput,
                    name: 'State',
                    bindings: ({ language, vehicle, vehicles, vehicleIndex }) => ({ vehicleIndex, vehicles, vehicle, label: `${language?.State || 'State'}:`, value: vehicle.state })
                },
                {
                    component: WrappedInputError,
                    name: 'StateError',
                    bindings: ({ vehicle }) => ({ error: vehicle.stateError }),
                    renderIf: ({ vehicle, onReview }) => !!vehicle.stateError && !onReview
                }
            ]
        },
        {
            component: Seprator,
            name: 'Seprator',
            displayValue: () => '',
            renderIf: ({ vehicle, vehicles }) => isLastItem({ resource:vehicle, resourceList:vehicles })
        },
    ],
}

export default ContainerComponent(Vehicle);
